module.exports = __webpack_public_path__ + "img/37.7ee50b58.jpg";